// extracted by mini-css-extract-plugin
export var actionButton = "_qb-0";
export var actionMenuContainer = "_qb-i";
export var bubble = "_qb-2";
export var bubbleActionMenu = "_qb-j";
export var bubbleContext = "_qb-6";
export var bubbleItems = "_qb-7";
export var customer = "_qb-3";
export var divider = "_qb-8";
export var fileList = "_qb-9";
export var hiddenComment = "_qb-o";
export var infoAbove = "_qb-a";
export var internal = "_qb-4";
export var lightActionButton = "_qb-1";
export var link = "_qb-b";
export var merchant = "_qb-5";
export var message = "_qb-c";
export var profilePicture = "_qb-e";
export var quillToolbarContainer = "_qb-f";
export var senderDate = "_qb-g";
export var senderDateCustomer = "_qb-h";
export var senderName = "_qb-d";
export var time = "_qb-k";
export var uploadedImage = "_qb-l";
export var username = "_qb-m";
export var xsmall = "_qb-n";